const Spinner = ({ height }) => {
    height = height || 48;
    let fontSize = Math.ceil(height * 0.75).toString() + "px";
    return <span>
        <span style={{ fontSize: fontSize }}>
            <img style={{ height: height.toString() + "px" }} src="/spinner.gif" alt="Loading" /> Loading...</span>
    </span>
}

export default Spinner